export enum Discounts {
  ZRGD = 'Regional Guideline',
  ZCUD = 'Contractual Discount',
  ZQSD = 'Quantity Discount', 
  ZLVD = 'Product/Volume Discount',
  ZHVD = 'Product/Volume Discount',
  ZSQD = 'Stock Order Discount',
  ZSVD = 'Stock Discount',
  ZSD1 = 'Manual Discount Adjustment',
  ZSD2 = 'Manual Discount Adjustment',
  ZDSH = 'Same Day Shipment',
  ZEDC = 'Lead Time Surcharge', 
  ZDOA = 'Coupon',
  ZR04 = 'List Price',
  ZR03 = 'List Price for manual price from SAP',
  ZF00 = 'Freight charge',
  ZSCG = 'Surcharge',
  ZLTD = 'Lead Time Discount',
  ZEPT = 'Manual Expedite Charge',
  ZAMP = 'Aftermarket Factor',
  ZTAR =  'Tariff Surcharge',
}
